import { Router } from '@angular/router';
import { Component } from '@angular/core';

@Component({
  selector: 'app-disclaimer-page',
  imports: [],
  templateUrl: './disclaimer-page.html',
  styleUrl: './disclaimer-page.css'
})
export class DisclaimerPage {
constructor(private router :Router){}
navigateAndScroll(route: string, x: number=0, y: number=0) {
    this.router.navigate([route]).then(() => {
      window.scrollTo(x, y);
    });
  }
}
